<template>
    <div class="modal fade" id="warehouse-create-modal-warehouse" tabindex="-1" aria-labelledby="warehouse-create-modal-warehouse" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('create_warehouse')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('label')}}</label> 
                        <input v-model="warehouse.name" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Name">
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('address')}}</label> 
                        <input v-model="warehouse.address" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Address">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || warehouse.name.length < 2"  @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" /> {{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
</template>

<script>
import helper from '../helper'
export default {
  name: 'AddWarehouse',
  props : ['state'],
  data(){
    return {
        warehouse : {
            id : null,
            name : '',
            address : ''
        },
        createModal : null,
        loading : false
    }
  },
  mounted(){

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('warehouse-create-modal-warehouse'))
    if(this.state === true){
       this.createModal.show()
    }

    document.getElementById('warehouse-create-modal-warehouse').addEventListener('hidden.bs.modal', () => { 
        this.$emit('createWarehouse',{state : false })
    })

  },
  methods : {
    create(){
        this.clearForm()

        // eslint-disable-next-line no-undef
        this.createModal.show()
    },
    async save(){
        try{
            this.loading = true
            const response = await helper.customPost(`${process.env.VUE_APP_API}/warehouses`,this.warehouse,{showToast:true})
            this.loading = false
            this.clearForm()
            this.$emit('createWarehouse',{warehouse : response.data, state : false })
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }

    },
    clearForm(){
        this.warehouse = {
            id : null,
            name : '',
            address : ''
        }
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) }
  }
}
</script>
